import { ArrowBendUpLeftIcon } from '@phosphor-icons/react';
import { useBackNavigation } from '@/lib/hooks/useBackNavigation';

interface HeaderProps {
  enableBack?: boolean;
  backTo?: string;
  fallbackTo?: string;
  additionalClasses?: string;
}

export function Header({
  enableBack = false,
  backTo,
  fallbackTo,
  additionalClasses = '',
}: HeaderProps) {
  const handleBack = useBackNavigation(backTo, fallbackTo);

  return (
    <header
      className={`flex justify-between items-center text-primary-foreground px-4 pt-5 pb-3 w-full [-webkit-app-region:drag] ${additionalClasses}`}
    >
      <div
        id="back-button-block"
        className="flex justify-between items-center gap-2"
      >
        {enableBack && (
          <button
            onClick={handleBack}
            aria-label="Go back"
            className="text-foreground p-0  no-underline gap-1.5 "
          >
            <ArrowBendUpLeftIcon size={24} weight="regular" />
          </button>
        )}
      </div>
    </header>
  );
}
